export class CreateChallengeParams {
  publicKey: string

  constructor({ publicKey }: { publicKey: string }) {
    this.publicKey = publicKey
  }
}
